import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const TabletScreen = createSvgIcon(
  () => (
    <path d="M2.33337 5C2.33337 2.24219 4.57556 0 7.33337 0H32.3334C35.0912 0 37.3334 2.24219 37.3334 5V35C37.3334 37.7578 35.0912 40 32.3334 40H7.33337C4.57556 40 2.33337 37.7578 2.33337 35V5ZM22.3334 35C22.3334 34.337 22.07 33.7011 21.6011 33.2322C21.1323 32.7634 20.4964 32.5 19.8334 32.5C19.1703 32.5 18.5344 32.7634 18.0656 33.2322C17.5968 33.7011 17.3334 34.337 17.3334 35C17.3334 35.663 17.5968 36.2989 18.0656 36.7678C18.5344 37.2366 19.1703 37.5 19.8334 37.5C20.4964 37.5 21.1323 37.2366 21.6011 36.7678C22.07 36.2989 22.3334 35.663 22.3334 35ZM32.3334 5H7.33337V30H32.3334V5Z" />
  ),
  '0 0 40 40'
);
